import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PagesComponent} from './pages.component';
import {routing} from './pages.routing';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MultiSelectModule} from 'primeng/primeng';
import {CollapseModule, ModalModule} from 'ngx-bootstrap';
// for loading theme
import {LayoutModule} from '../layout/layout.module';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';

@NgModule({
  imports: [
    CommonModule,
    routing, SharedTranslationModule,
    LayoutModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    MultiSelectModule,
    CollapseModule.forRoot(),
    ModalModule.forRoot()
  ],
  declarations: [PagesComponent],
  providers: []
})
export class PagesModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/pages/pages.module.ts